import api from '../lib/axios';
export async function getRoadworks() {
    const { data } = await api.get('/api/admin/roadworks');
    return data.data;
}
export async function createRoadwork(body) {
    const { data } = await api.post('/api/admin/roadworks', body);
    return data.data;
}
export async function updateRoadwork(id, body) {
    const { data } = await api.patch(`/api/admin/roadworks/${id}`, body);
    return data.data;
}
export async function deleteRoadwork(id) {
    await api.delete(`/api/admin/roadworks/${id}`);
}
export async function uploadRoadworkPhoto(file) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('module', 'travaux');
    formData.append('type', 'image');
    const { data } = await api.post('/api/v1/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data.url;
}
